const panSeparator = (inputValue?: string) => {
  let formattedValue = "";

  if (inputValue && inputValue.length)
    for (let i = 0; i < inputValue.length; i += 1) {
      if (i > 0 && i % 4 === 0) {
        formattedValue += "-";
      }
      formattedValue += inputValue[i];
    }

  return formattedValue;
};
export default panSeparator;
